<template>
    <div
        class="flex-col flex h-full relative overflow-hidden overflow-y-auto pb-10 px-2 scroll-smooth"
        ref="courseSidebar"
    >
        <div class="px-3 py-4 justify-start items-center gap-1 flex">
            <div class="text-slate-800 text-lg font-medium">Course lessons</div>
        </div>
        <div class="pb-8 pt-2 pl-3 pr-6 w-full">
            <ProgressBar />
        </div>
        <ul
            v-for="(section, i) in course.sections"
            :key="`${course.id}-${i}`"
            class="w-full flex-col flex"
        >
            <div
                :id="`section-${section.slug}`"
                class="w-full pl-3 pr-6 pb-3.5 gap-2.5 flex bg-slate-100 sticky top-0 z-10"
                :class="{
                    'pt-[22px]': i >= 1,
                    'pt-0': i === 0,
                }"
            >
                <h5 class="text-slate-800 font-medium">
                    {{ section.title }}
                    <span class="text-xs font-light text-slate-500">
                        ({{ section.chapters.length }} lesson{{
                            section.chapters.length > 1 ? 's' : ''
                        }})
                    </span>
                </h5>
            </div>
            <ListItem
                v-for="(chap, j) in section.chapters"
                :key="`${course.id}-${i}-${j}`"
                :chapter="chap"
                :showButtons="false"
                class="w-full"
                iconPosition="right"
            />
        </ul>
    </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useCoursesStore } from '@/store/courses';
import ListItem from '@/components/courses/chapter-list/list-item.vue';
import ProgressBar from '@/components/courses/progress-bar.vue';
import { ref, watch } from 'vue';

const coursesStore = useCoursesStore();
const { course, section, chapter, courseSidebarOpen } =
    storeToRefs(coursesStore);

const courseSidebar = ref(null);

const scrollToChapter = () => {
    let offsetPosition = 0;
    let elementPosition = 0;
    const sectionId = `section-${section.value.slug}`;
    const chapterId = `chapter-${chapter.value.slug}`;
    const sectionElement = document.getElementById(sectionId);
    const chapterElement = document.getElementById(chapterId);
    const headerOffset = sectionElement.getBoundingClientRect().height + 150;
    elementPosition = chapterElement.getBoundingClientRect().top;
    offsetPosition = elementPosition - headerOffset;

    if (offsetPosition > 0) {
        courseSidebar.value.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    }
};

watch(chapter, (newValue) => {
    if (newValue && courseSidebarOpen.value) {
        scrollToChapter();
    }
});

watch(courseSidebarOpen, (newValue) => {
    if (newValue) {
        setTimeout(() => {
            scrollToChapter();
        }, 250);
    }
});
</script>
